import { validator } from "@/utils/validator";

// Max lengths follow the ACC60C00 DD spec (Detailed Field Specs), not the DB column widths.
const MAX_NAME = 255; // 組織名
const MAX_ADDRESS_LINE = 80; // 町名丁目番地号等
const MAX_PHONE = 255; // 電話番号
const MAX_BANK_ACCOUNT = 1000; // 振込先口座情報
const MAX_INVOICE_REGISTRATION = 14; // インボイス登録番号 (T + 13 digits)

// インボイス登録番号: T + 13 digits.
const INVOICE_REGISTRATION_PATTERN = /^T\d{13}$/;

export const organizationSchema = validator.object().shape({
  name: validator.string().trim().emptyToNull().label("組織名").max(MAX_NAME).required(),

  // 郵便番号 — same validation as RSO/紹介会社: half-width transform + zipCode format.
  zipCode: validator.string().emptyToNull().autoTransformToHalfWidth().zipCode().trim().label("郵便番号").notRequired(),

  // 都道府県 — read-only, auto-filled from zip lookup (spec defines no length).
  province: validator.string().trim().emptyToNull().label("都道府県").notRequired(),

  // 市区町村 — read-only / select, auto-filled from zip lookup (spec defines no length).
  municipality: validator.string().trim().emptyToNull().label("市区町村").notRequired(),

  // 町名丁目番地号等 — manual entry.
  addressLine: validator.string().trim().emptyToNull().nullable().label("町名丁目番地号等").notRequired().max(MAX_ADDRESS_LINE),

  // 電話番号
  phone: validator.string().trim().emptyToNull().autoTransformToHalfWidth().isTelNumber().label("電話番号").notRequired().max(MAX_PHONE),

  // インボイス登録番号 — optional. Empty/null passes; any real value must be T + 13 digits
  // and within max length. The field displays a bare "T" prefix as an input helper when the
  // stored value is empty, so a lone "T" (prefix only, nothing typed) is treated as empty —
  // it must not raise a validation error, and is persisted as null (see organizationConverts).
  invoiceRegistrationNumber: validator
    .string()
    .trim()
    .transform((value) => (typeof value === "string" && value.trim() === "T" ? "" : value))
    .emptyToNull()
    .autoTransformToHalfWidth()
    .nullable()
    .label("インボイス登録番号")
    .max(MAX_INVOICE_REGISTRATION)
    .matches(INVOICE_REGISTRATION_PATTERN, { message: "登録番号はT + 13桁で入力してください。", excludeEmptyString: true })
    .notRequired(),

  // 振込先口座情報
  bankAccount: validator.string().trim().emptyToNull().label("振込先口座情報").max(MAX_BANK_ACCOUNT).required(),
});
